<script>
import searchResultsTabMixin from '@phoenix/mixins/searchResultsTabMixin';
import SearchResultsTab from '@maison/components/search/SearchResultsTab';
import ArticleTile from '@maison/components/article/ArticleTile';
import { TAB_ARTICLES } from '@maison/helpers/search-helper';
import { IndexNames } from '@module/Algolia/resources/js/search/AlgoliaSearch';
import { algoliaTracking } from '@module/Algolia/resources/js/insights/helpers';

export default {
  components: {
    SearchResultsTab,
    ArticleTile,
  },

  mixins: [searchResultsTabMixin],

  data() {
    return {
      tab: TAB_ARTICLES,
    };
  },

  methods: {
    onArticleClick(article, position) {
      algoliaTracking(article, position, IndexNames.Articles);
    },
  },
};
</script>

<template>
  <search-results-tab :tab="tab" :limit="limit" has-paging-label>
    <ul class="grid gap-base lg:grid-cols-3" role="presentation">
      <li v-for="(article, index) in items" :key="article.id" role="presentation">
        <article-tile v-bind="article" :data-tracking="dataTracking" @click="onArticleClick(article, index)" />
      </li>
    </ul>
  </search-results-tab>
</template>
